"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const howler_1 = require("howler");
const Definable_1 = __importDefault(require("./Definable"));
const state_1 = __importDefault(require("../state"));
const isRunningOnLocal_1 = __importDefault(require("../functions/isRunningOnLocal"));
const assetsAreLoaded_1 = __importDefault(require("../functions/assetsAreLoaded"));
class AudioSource extends Definable_1.default {
    constructor(slug, loopPoint) {
        super(slug);
        this._fadeVolume = 0.5;
        this._fadeInAction = null;
        this._fadeOutAction = null;
        this._onEnds = [];
        this._onPlay = null;
        this._loopPoint = null;
        this._plays = 0;
        this._muted = false;
        this._loopPoint = loopPoint;
        this._howl = new howler_1.Howl({
            autoplay: false,
            loop: false,
            preload: true,
            src: [this.getSRC()],
            volume: .5
        });
        this._howl.on("end", () => {
            this.onHowlEnd();
        });
        this._howl.on("fade", () => {
            this.onHowlFade();
        });
        this._howl.on("load", () => {
            this.onHowlLoad();
        });
        this._howl.on("play", () => {
            this.onHowlPlay();
        });
    }
    applyVolume(volume) {
        if (this._fadeInAction !== null) {
            if (this._fadeInAction.startedAt !== null) {
                const percent = this._howl.volume() / this._fadeVolume;
                const duration = this._fadeInAction.duration - (state_1.default.currentTime - this._fadeInAction.startedAt);
                this._howl.fade(percent * volume, volume, duration);
            }
        }
        else if (this._fadeOutAction !== null) {
            if (this._fadeOutAction.startedAt !== null) {
                const percent = 1 - this._howl.volume() / this._fadeVolume;
                const duration = this._fadeOutAction.duration - (state_1.default.currentTime - this._fadeOutAction.startedAt);
                this._howl.fade(percent * volume, 0, duration);
            }
        }
        else {
            this._howl.volume(volume);
        }
        this._fadeVolume = volume;
    }
    fadeIn(duration) {
        this._fadeInAction = {
            duration,
            startedAt: state_1.default.currentTime
        };
        this._howl.fade(0, this._fadeVolume, duration);
    }
    fadeOut(duration) {
        this._fadeOutAction = {
            duration,
            startedAt: state_1.default.currentTime
        };
        this._howl.fade(this._fadeVolume, 0, duration);
    }
    isPlaying() {
        return this._howl.playing();
    }
    mute() {
        this._muted = true;
        this._howl.mute(true);
    }
    pause() {
        this._howl.pause();
    }
    play(onPlay, onEnd) {
        this._onPlay = onPlay;
        this._onEnds.push(onEnd);
        this._howl.play();
    }
    resume() {
        if (this._howl.playing() === false) {
            this._howl.play();
        }
    }
    stop() {
        this._howl.stop();
    }
    unmute() {
        this._muted = false;
        this._howl.mute(false);
    }
    cancelOnEnds() {
        this._onEnds = [];
    }
    toggleMute() {
        if (this._muted) {
            this.unmute();
        }
        else {
            this.mute();
        }
    }
    getSRC() {
        if ((0, isRunningOnLocal_1.default)()) {
            return `./out/audio/${this._slug}.mp3`;
        }
        return `./audio/${this._slug}.mp3`;
    }
    onHowlEnd() {
        if (this._loopPoint !== null) {
            this.stop();
            this._howl.seek(this._loopPoint / 1000);
            this._howl.play();
        }
        if (this._onEnds[0]) {
            this._onEnds[0]();
        }
        this._onEnds.shift();
    }
    onHowlFade() {
        if (this._fadeInAction !== null) {
            this._fadeInAction = null;
        }
        if (this._fadeOutAction !== null) {
            this.stop();
            this._fadeOutAction = null;
            this._howl.volume(this._fadeVolume);
        }
    }
    onHowlLoad() {
        var _a, _b;
        state_1.default.loadedAssets++;
        if ((0, assetsAreLoaded_1.default)()) {
            (_a = document.getElementById("screen")) === null || _a === void 0 ? void 0 : _a.classList.remove("loading");
            (_b = document.getElementById("screen")) === null || _b === void 0 ? void 0 : _b.classList.add("focus");
        }
    }
    onHowlPlay() {
        if (this._plays === 0 && this._onPlay !== null) {
            this._onPlay();
        }
        this._plays++;
    }
}
exports.default = AudioSource;
